import React, {ReactNode} from "react";
import styled from "@emotion/styled";
import {useMediaQuery} from "react-responsive";
import {PHONE_MAX_WIDTH} from "../utils/constants";

const Container = styled.div({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
});

const Artboard = styled.div({
    position: "relative",
    width: "90%",
    height: "90%",
    backgroundColor: "white",
    borderRadius: "10px",
    overflow: "hidden"
});

interface WorkspaceProps {
    children: ReactNode;
}

function Workspace(props: WorkspaceProps) {

    const { children } = props;

    const isPhone = useMediaQuery({maxWidth: PHONE_MAX_WIDTH});
    const height = isPhone ? "calc(var(--vh, 1vh) * 85)" : "calc(var(--vh, 1vh) * 100)";

    return (
        <Container style={{height: height}}>
            <Artboard id="artboard">
                {!!children && children}
            </Artboard>
        </Container>
    );
}

export default Workspace;